<template>
    <div>
        <ams-base-chart chartTitle="Outcome Type By Callsign" :chartType="ChartTypes.BAR" :data="chartData" :stacked="true" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { ChartTypes } from '../../../../../../enums';
import { toCapitalize } from '../../../../../../utilities';
import { Colors } from '../../../../../../utilities/colors';

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const loadChartData = async () => {
    const jsonArray = props.jsonData;
    const colors = [Colors.BLUE, Colors.AMBER, Colors.RED];
    chartData.value = jsonArray
        ?.map((data) => {
            return {
                label: toCapitalize(data.name),
                values: data.outcomes
                    ?.filter((item) => item.name !== 'None')
                    ?.map((outcome, index) => {
                        return {
                            label: outcome.name,
                            bgcolor: colors[index],
                            value: outcome.tot ?? 0,
                        };
                    }),
            };
        })
        ?.filter((obj) => obj.values.length > 0);
};
</script>
